(() => {
  const init = () => document.querySelectorAll('iframe[data-application-autoplay]').forEach(frame => {
    if (frame.dataset.autoplayReady) return;
    frame.dataset.autoplayReady = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    const command = (func, args = []) => frame.contentWindow?.postMessage(JSON.stringify({event:'command',func,args}), new URL(frame.src).origin);
    const sync = () => {
      command('mute');
      command(visible && !document.hidden && !reduced.matches ? 'playVideo' : 'pauseVideo');
    };
    const src = new URL(frame.src);
    src.searchParams.set('enablejsapi','1');src.searchParams.set('origin',location.origin);
    src.searchParams.set('playsinline','1');src.searchParams.set('mute','1');
    src.searchParams.set('autoplay',reduced.matches ? '0' : '1');
    frame.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
    frame.addEventListener('load', () => {sync();setTimeout(sync,500);setTimeout(sync,1500);});
    if (frame.src !== src.href) frame.src = src.href;
    new IntersectionObserver(entries => {visible=entries[0].isIntersecting;sync();}, {threshold:.25}).observe(frame);
    document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);
    window.addEventListener('message',event=>{if(event.source!==frame.contentWindow)return;let message;try{message=typeof event.data==='string'?JSON.parse(event.data):event.data;}catch{return;}if(message?.event==='onReady')sync();});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
